<template>
  <div class="container text-center">
    <div class="row h-100">
      <div class="col-sm-12 my-auto">
        <div class="card-block mx-auto">
          <form class="form-signin" @submit.prevent="login">
            <img
              class="mb-4 home-logo"
              src="https://static.innovorder.fr/io/images/logo-new.png"
              alt=""
            />
            <br />
            <label for="inputEmail" class="sr-only">Email</label>
            <input
              type="email"
              id="inputEmail"
              class="form-control"
              placeholder="Email"
              v-model="email"
              required
            />

            <label for="inputPassword" class="sr-only">Password</label>
            <input
              type="password"
              id="inputPassword"
              class="form-control"
              placeholder="Password"
              v-model="password"
              required
            />

            <button
              class="btn btn-lg btn-innovorder btn-block"
              type="submit"
              :disabled="loading"
            >
              <div v-if="loading" class="loader mx-auto"></div>
              <div v-if="!loading">Se connecter</div>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../firebaseDb";
import axios from "axios";

export default {
  data() {
    return {
      password: "",
      email: "",
      loading: false,
    };
  },
  methods: {
    login() {
      if (!this.email || !this.password) {
        alert("Veuillez saisir un email ou mot de passe.");
      }
      this.loading = true;

      axios
        .post("/api/auth", { email: this.email, password: this.password })
        .then((response) => {
          const token = response.data.token;
          const restaurantId = response.data.restaurantId;
          this.$cookies.set("ods-restaurant-id", restaurantId);
          this.$cookies.set("ods-auth-token", token);
          return db.app.auth().signInWithCustomToken(token);
        })
        .then(() => {
          this.$router.push("/create");
        })
        .catch((error) => {
          this.loading = false;
          alert(
            "Il y a une erreur dans votre email ou votre mot de passe, veuillez re-essayer.",
            error.message
          );
        });
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  background-color: #f5f5f5;
}
</style>
<style scoped>
.home-logo {
  max-width: 250px;
  margin-bottom: 20px;
}
.container {
  height: 100%;
}
.btn-innovorder {
  font-family: avenirBook, avenir, sans-serif !important;
  font-weight: 800 !important;
  font-weight: 800;
  color: #fff;
  font-size: 18px;
  background-color: #f96d6d;
  border-radius: 8px;
  height: 50px;
  width: 100%;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>

<style lang="scss" scoped>
.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
